import { render, staticRenderFns } from "./zadarmaChat.vue?vue&type=template&id=006cbd75&lang=pug&"
import script from "./zadarmaChat.vue?vue&type=script&lang=ts&"
export * from "./zadarmaChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports